const colors = {
  white: '#FFFFFF',
  transparent: 'rgba(0,0,0,0)',

  primary: '#FFFFFF', //'#FFFFFF', // // White
  accent: '#468C7F', // Green
  secondary: '#F2C53D', // Yellow
  tertiary: '#FF896E', // Coral / Red
  quartiary: '#8C6BEB', // Purple
  textStrong: '#000000DE',
  textMedium: '#00000099',
  textUnderline: '#000000',
  textImageoverlay: '#EFEFEF',

  backgroundExtraLight: '#FFFFFF',
  backgroundDark: '#efefef77',
  backgroundLight: '#f9f9f9cc',
  backgroundMedium: '#D9D9D9',

  backgroundAccent: '#468C7FAA',

  disabled: '#A6A6A6',
  active: '#FFFFFF',
  success: '#008C0B',
  danger: '#C65050',
  info: '#2996FD',
  backdrop: '#468C7FAA',

  borderLight: '#DEDEDE',
  borderMedium: '#F2C43DDE',
  borderDark: '#00000099',
};

export default colors;
